import { cn } from "@babackapp/ui/lib/utils";
import { getSocialIconPngUrl } from "@babackapp/ui/lib/social-icons";
import { useMemo } from "react";
import { Column, Img, Link, Row } from "@react-email/components";
import type { SocialNetworksBlockProps } from "./types";
import { useSocialIconColor } from "./use-social-icon-color";


export function SocialNetworksEmailRenderer({
                                              block,
                                              shop,
                                              section = "inside",
                                              theme,
                                            }: SocialNetworksBlockProps) {
  const alignment = block.alignment || "center";
  const iconColor = useSocialIconColor(theme, section);

  const socialNetworks = useMemo(() => {
    return shop.externalLinks
      ? Object.entries(shop.externalLinks)
        .filter(([_, link]) => link?.type === "SOCIAL_NETWORK" && link?.url)
        .map(([platform, link]) => ({
          platform,
          url: link!.url,
          iconUrl: getSocialIconPngUrl(platform, iconColor),
        }))
      : [];
  }, [shop.externalLinks, iconColor]);

  if (socialNetworks.length === 0) {
    return null;
  }

  return (
    <Row>
      <Column
        className={cn({
          "text-left": alignment === "left",
          "text-center": alignment === "center",
          "text-right": alignment === "right",
        })}
      >
        {socialNetworks.map(({ platform, url, iconUrl }) => (
          <Link
            key={platform}
            href={url}
            className="mx-2"
            style={{
              display: "inline-block",
              textDecoration: "none",
            }}
          >
            <Img
              src={iconUrl}
              alt={platform}
              width={24}
              height={24}
              style={{
                display: "block",
                width: "24px",
                height: "24px",
              }}
            />
          </Link>
        ))}
      </Column>
    </Row>
  );
}
